import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 1rem;
    align-items: center;

    > button {
      position: relative;
      height: 1.5rem;
      width: 2.75rem;
      border-radius: 0.75rem;
      flex-shrink: 0;

      cursor: pointer;

      background-color: ${theme.palette.neutral[300]};
      transition: background-color 0.2s;

      span {
        position: absolute;
        top: 0.125rem;
        left: 0.125rem;
        height: 1.25rem;
        width: 1.25rem;
        border-radius: 50%;

        background-color: ${theme.palette.text.white};
        transition: transform 0.2s;
      }

      &[data-state='checked'] {
        background-color: ${theme.palette.primary.main};

        span {
          transform: translateX(1.25rem);
        }
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }

    label {
      cursor: pointer;
      font-weight: ${theme.typography.weight.bold};
    }
  `}
`;
